module.exports = __webpack_public_path__ + "static/media/footer.9b1a3f52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/images/footer.jpg
// module id = 1125
// module chunks = 0